import { render, staticRenderFns } from "./ListItemSkeleton.vue?vue&type=template&id=71650ee2&scoped=true&"
import script from "./ListItemSkeleton.vue?vue&type=script&lang=js&"
export * from "./ListItemSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ListItemSkeleton.vue?vue&type=style&index=0&id=71650ee2&scoped=true&lang=css&"
import style1 from "./ListItemSkeleton.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71650ee2",
  null
  
)

export default component.exports